import { UserStore } from '@/utils/UserStore';

const mutations = {
  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state:any, value:any) {
      state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state:any, value:any) {
      state.reduceButton = value
  },
  UPDATE_MAIN_LAYOUT_TYPE(state:any, value:any) {
      state.mainLayoutType = value
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state:any, value:any) {
      state.verticalNavMenuItemsMin = value
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state:any, width:any) {
      state.verticalNavMenuWidth = width
  },
  UPDATE_STARRED_PAGE(state:any, payload:any) {

      // find item index in search list state
      const index = state.navbarSearchAndPinList["pages"].data.findIndex((item:any) => item.url == payload.url)

      // update the main list
      state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

      // if val is true add it to starred else remove
      if (payload.val) {
          state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
      } else {
          // find item index from starred pages
          const index = state.starredPages.findIndex((item:any) => item.url == payload.url)

          // remove item using index
          state.starredPages.splice(index, 1)
      }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state:any, list:any) {
      const starredPagesMore = state.starredPages.slice(10)
      state.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state:any, list:any) {
      let downToUp = false
      const lastItemInStarredLimited = state.starredPages[10]
      const starredPagesLimited = state.starredPages.slice(0, 10)
      state.starredPages = starredPagesLimited.concat(list)

      state.starredPages.slice(0, 10).map((i:Number) => {
          if (list.indexOf(i) > -1) downToUp = true
      })

      if (!downToUp) {
          state.starredPages.splice(10, 0, lastItemInStarredLimited)
      }
  },

  TOGGLE_CONTENT_OVERLAY(state:any, value:any) {
      state.bodyOverlay = value
  },
  UPDATE_PRIMARY_COLOR(state:any, value:any) {
      state.themePrimaryColor = value
  },
  UPDATE_THEME(state:any, value:any) {
      state.theme = value
  },
  UPDATE_WINDOW_WIDTH(state:any, width:any) {
      state.windowWidth = width
  },
  UPDATE_WINDOW_SCROLL_Y(state:any, value:any) {
      state.scrollY = value
  },

  UPDATE_USER_INFO(state:any, payload:any) {

      const user = UserStore();
      // Get Data localStorage
      const userInfo = JSON.parse(localStorage.getItem("userInfo")||"") || state.AppActiveUser
      //const userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser

      for (const property of Object.keys(payload)) {

          if (payload[property] != null) {
              // If some of user property is null - user default property defined in state.AppActiveUser
              state.AppActiveUser[property] = payload[property]

              // Update key in localStorage
              userInfo[property] = payload[property]
          }


      }
      // Store data in localStorage
      localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
}

export default mutations

